import React from 'react';
import { Button } from '../../global-styles';
import { AiFillThunderbolt } from 'react-icons/ai';
import { GiCrystalBars } from 'react-icons/gi';
import { GiCutDiamond, GiRock } from 'react-icons/gi';
import { GiFloatingCrystal } from 'react-icons/gi';
import { IconContext } from 'react-icons/lib';
import {
  PricingSection,
  PricingWrapper,
  PricingHeading,
  PricingContainer,
  PricingCard,
  PricingCardInfo,
  PricingCardIcon,
  PricingCardPlan,
  // PricingCardCost,
  // PricingCardLength,
  PricingCardFeatures,
  PricingCardFeature
} from './Pricing.elements';

function Pricing() {
  return (
    <IconContext.Provider value={{ color: '#a9b3c1', size: 64 }}>
      <PricingSection>
        <PricingWrapper>
          <PricingHeading>Our Services</PricingHeading>
          <PricingContainer>
            <PricingCard to='/counseling?type=freelance'>
              <PricingCardInfo>
                <PricingCardIcon>
                  <GiFloatingCrystal />
                </PricingCardIcon>
                <PricingCardPlan>Freelance Support</PricingCardPlan>
                <PricingCardFeatures>
                  <PricingCardFeature>Project Guidance</PricingCardFeature>
                  <PricingCardFeature>Code Review</PricingCardFeature>
                  <PricingCardFeature>Real-world Tech Help</PricingCardFeature>
                </PricingCardFeatures>
                <Button primary>Contact Us</Button>
              </PricingCardInfo>
            </PricingCard>
            <PricingCard to='/products'>
              <PricingCardInfo>
                <PricingCardIcon>
                  <AiFillThunderbolt />
                </PricingCardIcon>
                <PricingCardPlan>Interview Prep</PricingCardPlan>
                <PricingCardFeatures>
                  <PricingCardFeature>Coding Interviews</PricingCardFeature>
                  <PricingCardFeature>System Design</PricingCardFeature>
                  <PricingCardFeature>Behavioral Practice</PricingCardFeature>
                </PricingCardFeatures>
                <Button primary>See Courses</Button>
              </PricingCardInfo>
            </PricingCard>
            <PricingCard to='/counseling?type=coaching'>
              <PricingCardInfo>
                <PricingCardIcon>
                  <GiCutDiamond />
                </PricingCardIcon>
                <PricingCardPlan>1:1 Coaching</PricingCardPlan>
                <PricingCardFeatures>
                  <PricingCardFeature>Career Guidance</PricingCardFeature>
                  <PricingCardFeature>Technical Mentoring</PricingCardFeature>
                  <PricingCardFeature>Personal Growth</PricingCardFeature>
                </PricingCardFeatures>
                <Button primary>Get Support</Button>
              </PricingCardInfo>
            </PricingCard>
          </PricingContainer>
        </PricingWrapper>
      </PricingSection>
    </IconContext.Provider>
  );
}
export default Pricing;
